/**
 * size-selector.js — printbrain.jp サイズ選択ウィジェット
 * 配置先: Assets/size-selector.js
 */

(function () {
  'use strict';

  function getSizes() {
    const el = document.getElementById('pb-size-selector-root');
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.dataset.pbSizes || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  let selectedSize = null;

  function setSize(sizeName) {
    selectedSize = sizeName;

    document.querySelectorAll('.pb-size-btn').forEach(function (btn) {
      const active = btn.dataset.size === sizeName;
      btn.classList.toggle('pb-size-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    const label = document.getElementById('pb-selected-size-label');
    if (label) {
      label.textContent = sizeName;
      label.classList.add('pb-ss-selected--chosen');
    }
  }

  function buildUI(sizes) {
    const root = document.getElementById('pb-size-selector-root');
    if (!root || sizes.length === 0) {
      if (root) root.style.display = 'none';
      return;
    }

    const header = document.createElement('div');
    header.className = 'pb-ss-header';
    header.innerHTML =
      '<span class="pb-ss-label">サイズ：</span>' +
      '<span id="pb-selected-size-label" class="pb-ss-selected">未選択</span>';
    root.appendChild(header);

    const grid = document.createElement('div');
    grid.className = 'pb-ss-grid';
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', 'サイズを選択');

    sizes.forEach(function (item) {
      const name = typeof item === 'string' ? item : item.name;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pb-size-btn';
      btn.dataset.size = name;
      btn.textContent = name;
      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function () { setSize(name); });
      grid.appendChild(btn);
    });

    root.appendChild(grid);
  }

  // fetchをインターセプトしてサイズをline_propertiesに付加
  function interceptFetch(sizes) {
    if (sizes.length === 0) return;

    const originalFetch = window.fetch;

    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : (input.url || '');

      if (url.includes('/cart/add')) {
        const sizeValue = selectedSize || '未選択';

        try {
          init = init ? Object.assign({}, init) : {};
          const body = init.body;

          if (typeof body === 'string') {
            try {
              const parsed = JSON.parse(body);
              parsed.properties = parsed.properties || {};
              parsed.properties['サイズ'] = sizeValue;
              init.body = JSON.stringify(parsed);
            } catch (e) {
              init.body = body +
                '&properties%5B%E3%82%B5%E3%82%A4%E3%82%BA%5D=' +
                encodeURIComponent(sizeValue);
            }
          } else if (body instanceof FormData) {
            const newFd = new FormData();
            for (const pair of body.entries()) {
              newFd.append(pair[0], pair[1]);
            }
            newFd.set('properties[サイズ]', sizeValue);
            init.body = newFd;
          } else {
            const fd = new FormData();
            fd.append('properties[サイズ]', sizeValue);
            init.body = fd;
          }
        } catch (e) {
          console.warn('[size-selector] bodyの加工に失敗:', e);
        }
      }

      return originalFetch.call(this, input, init);
    };
  }

  function init() {
    if (!document.getElementById('pb-size-selector-root')) return;

    const sizes = getSizes();
    buildUI(sizes);

    if (sizes.length > 0) {
      interceptFetch(sizes);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
